import {Fragment} from 'react';

export default Fragment;
